import { Option } from 'components/SelectInput/SelectInput';

const variableOptionsListToSelectInputOptions = (optionsList: string[] = []) =>
  optionsList.map(
    (value): Option => ({
      name: value,
      value,
    }),
  );

export default variableOptionsListToSelectInputOptions;
